<template>
  <div
    v-if="formData"
    class="fin-form solid-table"
    :class="{ dark: theme === 'dark' }"
  >
    <div class="fin-form-header" v-if="!backend">
      {{ nameLabel || '--' }}
    </div>
    <div class="fin-form-content">
      <el-form
        size="mini"
        :inline="true"
        ref="form"
        :model="formData"
        :rules="rules"
        label-suffix="："
      >
        <el-collapse v-model="collapseModel">
          <el-collapse-item title="基础信息" name="type">
            <el-form-item
              label="方案名称"
              prop="name"
              ref="name"
              v-if="!backend"
            >
              <el-input
                placeholder="请输入方案名称"
                v-model="formData.name"
                :rules="rules.name"
                :maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="风场类型" prop="landOrSea" ref="landOrSea">
              <el-select :value="formData.landOrSea" @change="changeLandOrSea">
                <el-option label="陆地风场" :value="1"></el-option>
                <el-option label="海上风场" :value="2"></el-option>
              </el-select>
              <div style="font-size:10px">切换模板后表单会被重新填充</div>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="关键指标" name="important">
            <el-form-item
              label="运营期（年）"
              prop="operatingPeriod"
              ref="operatingPeriod"
              :rules="rules.operatingPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.operatingPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="建设期（年）"
              prop="constructionPeriod"
              ref="constructionPeriod"
              :rules="rules.constructionPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.constructionPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item label="装机容量（MW）" prop="cap" ref="cap">
              <el-input placeholder="请输入" v-model="formData.cap"></el-input>
            </el-form-item>

            <el-form-item
              label="静态总投资（万元）"
              prop="staticTotalInvestment"
              ref="staticTotalInvestment"
            >
              <total-invest
                v-model="formData.staticTotalInvestment"
                :cap="+formData.cap"
                :base="baseValue"
                :backend="backend"
                :key="formData.economicId"
                @click="totalInvestVisible = true"
              ></total-invest>
              <total-invest-dialog
                v-if="!backend"
                :visible.sync="totalInvestVisible"
                :planId="formData.planId"
                :economicId="formData.economicId"
                :formData="formData"
                @changeInvestDetail="changeInvestDetail"
                @changeStaticTotalInvestment="changeStaticTotalInvestment"
              >
              </total-invest-dialog>
            </el-form-item>
            <el-form-item
              label="资本金比例（%）"
              prop="capitalRate"
              ref="capitalRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.capitalRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="长期贷款利率（%）"
              prop="loanInterestRate"
              ref="loanInterestRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.loanInterestRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="满发小时数（h）"
              prop="equivalentHour"
              ref="equivalentHour"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.equivalentHour"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="含税电价（元/kwh）"
              prop="priceWith"
              ref="priceWith"
            >
              <e-price v-model="formData.priceWith"></e-price>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="基本参数" name="basic">
            <el-divider content-position="left">年限和装机容量</el-divider>
            <el-form-item
              label="运营期（年）"
              prop="operatingPeriod"
              ref="operatingPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.operatingPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="建设期（年）"
              prop="constructionPeriod"
              ref="constructionPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.constructionPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="开工年份"
              prop="constructionStarttime"
              ref="constructionStarttime"
            >
              <el-date-picker
                v-model="formData.constructionStarttime"
                type="year"
                style="width:200px"
                placeholder="请输入开工年份"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="装机容量（MW）" prop="cap">
              <el-input placeholder="请输入" v-model="formData.cap"></el-input>
            </el-form-item>

            <el-divider content-position="left">建设期分年度投资</el-divider>
            <el-form-item
              label="静态总投资（万元）"
              prop="staticTotalInvestment"
            >
              <total-invest
                v-model="formData.staticTotalInvestment"
                :cap="+formData.cap"
                :base="baseValue"
                :backend="backend"
                :key="formData.economicId"
                @click="totalInvestVisible = true"
              ></total-invest>
            </el-form-item>
            <cap-year-input
              v-model="formData.constructionInvestArr"
              label="分年度投资（万元）"
              prop="constructionInvestArr"
              ref="constructionInvestArr"
              :base="1"
              :cap="+formData.staticTotalInvestment"
              :count="constructionPeriodCount"
              :rules="rules.constructionInvest"
            />
            <el-form-item
              label="可抵扣增值税比例（%）"
              prop="vatRate"
              ref="vatRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.vatRate"
              ></el-input>
            </el-form-item>
            <multi-input
              v-model="formData.immaterialAssetsArr"
              prop="immaterialAssetsArr"
              ref="immaterialAssetsArr"
              :rules="rules.immaterialAssets"
              label="无形资产（万元）"
              defaultValue="0"
              :count="constructionPeriodCount"
            >
            </multi-input>
            <multi-input
              v-model="formData.otherAssetsArr"
              prop="otherAssetsArr"
              ref="otherAssetsArr"
              :rules="rules.otherAssets"
              label="其他资产（万元）"
              defaultValue="0"
              :count="constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">资本金投入</el-divider>
            <el-form-item
              label="资本金比例（%）"
              prop="capitalRate"
              ref="capitalRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.capitalRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="资本金基准收益率-贴现率（%）"
              prop="marr"
              ref="marr"
            >
              <el-input placeholder="请输入" v-model="formData.marr"></el-input>
            </el-form-item>
            <el-form-item
              label="行业基准收益率（所得税前）（%）"
              prop="marrBeforeTax"
              ref="marrBeforeTax"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.marrBeforeTax"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="行业基准收益率（所得税后）（%）"
              prop="marrAfterTax"
              ref="marrAfterTax"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.marrAfterTax"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">流动资金及短期贷款</el-divider>
            <el-form-item
              label="单位千瓦流动资金（元/kw）"
              prop="fluidUnit"
              ref="fluidUnit"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.fluidUnit"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="流动资金贷款比例（%）"
              prop="fluidLoanRatio"
              ref="fluidLoanRatio"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.fluidLoanRatio"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="流动资金贷款利率（%）"
              prop="fluidLoanRate"
              ref="fluidLoanRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.fluidLoanRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="短期贷款利率（%）"
              prop="shortLoanRate"
              ref="shortLoanRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.shortLoanRate"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">长期借款利息</el-divider>
            <el-form-item
              label="贷款年限（年）"
              prop="repaymentPeriod"
              ref="repaymentPeriod"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.repaymentPeriod"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="还款类型（%）"
              prop="repayType"
              ref="repayType"
            >
              <el-select
                placeholder="请选择还款类型"
                v-model="formData.repayType"
              >
                <el-option label="等额本息" :value="0"></el-option>
                <el-option label="等额本金" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="长期贷款利率（%）"
              prop="loanInterestRate"
              ref="loanInterestRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.loanInterestRate"
              ></el-input>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="成本费用" name="cost">
            <el-divider content-position="left">折旧费</el-divider>
            <el-form-item label="残值率（%）" prop="salvage" ref="salvage">
              <el-input
                placeholder="请输入"
                v-model="formData.salvage"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="折旧数据类型"
              prop="depreciableType"
              ref="depreciableType"
            >
              <el-select
                placeholder="请选择折旧数据类型"
                :disabled="backend"
                v-model="formData.depreciableType"
              >
                <el-option label="折旧年限" :value="0"></el-option>
                <el-option label="综合折旧率" :value="1"></el-option>
                <el-option label="手动输入折旧费" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="depreciableData"
              ref="depreciableData"
              v-if="+formData.depreciableType !== 2"
              :label="
                ['折旧年限（年）', '综合折旧率（%）', '折旧费（万元）'][
                  formData.depreciableType
                ]
              "
            >
              <el-input
                placeholder="请输入"
                v-model="formData.depreciableData"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.depreciableType === 2"
              v-model="formData.depreciableDataArr"
              prop="depreciableDataArr"
              ref="depreciableDataArr"
              :rules="rules.depreciableData"
              :label="
                ['折旧年限（年）', '综合折旧率（%）', '折旧费（万元）'][
                  formData.depreciableType
                ]
              "
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">维修费</el-divider>
            <el-form-item
              label="维修数据单位"
              prop="maintainType"
              ref="maintainType"
            >
              <el-select
                placeholder="请选择维修数据单位"
                :disabled="backend"
                v-model="formData.maintainType"
              >
                <el-option label="%" :value="0"></el-option>
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据维数" prop="maintainNum" ref="maintainNum">
              <el-select
                placeholder="请选择数据维数"
                :disabled="backend"
                v-model="formData.maintainNum"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="+formData.maintainNum === 0"
              prop="maintainData"
              ref="maintainData"
              :label="
                `${['维修费率', '单位维修费', '维修费'][formData.maintainType]}`
              "
            >
              <el-input
                placeholder="请输入"
                v-model="formData.maintainData"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.maintainNum === 1"
              v-model="formData.maintainDataArr"
              prop="maintainDataArr"
              ref="maintainDataArr"
              :rules="rules.maintainData"
              :label="
                `${['维修费率', '单位维修费', '维修费'][formData.maintainType]}`
              "
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">人工工资及福利</el-divider>
            <el-form-item
              label="人员种类"
              prop="staffTypeNum"
              ref="staffTypeNum"
              :rules="rules.staffTypeNum"
            >
              <el-input v-model="formData.staffTypeNum" placeholder="请输入" />
            </el-form-item>
            <multi-input
              v-model="formData.staffCapacityArr"
              prop="staffCapacityArr"
              ref="staffCapacityArr"
              :rules="rules.staffCapacity"
              label="人员数量"
              unit="种"
              :count="staffTypeNumCount"
            >
            </multi-input>
            <multi-input
              v-model="formData.staffSalaryArr"
              prop="staffSalaryArr"
              ref="staffSalaryArr"
              :rules="rules.staffSalary"
              label="人均年平均工资（万元/年）"
              unit="种"
              :count="staffTypeNumCount"
            >
            </multi-input>
            <multi-input
              v-model="formData.welfareRateArr"
              prop="welfareRateArr"
              ref="welfareRateArr"
              :rules="rules.welfareRate"
              label="福利系数（%）"
              unit="种"
              :count="staffTypeNumCount"
            >
            </multi-input>

            <el-divider content-position="left">保险费</el-divider>
            <el-form-item
              label="保险数据单位"
              prop="insureType"
              ref="insureType"
            >
              <el-select
                placeholder="请选择保险数据单位"
                :disabled="backend"
                v-model="formData.insureType"
              >
                <el-option label="%" :value="0"></el-option>
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保险计算方式" prop="insureNum" ref="insureNum">
              <el-select
                placeholder="请选择保险计算方式"
                :disabled="backend"
                v-model="formData.insureNum"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保险计算基数" prop="insureRaw" ref="insureRaw">
              <el-select
                placeholder="请选择保险计算基数"
                v-model="formData.insureRaw"
              >
                <el-option label="固定资产原值" :value="0"></el-option>
                <el-option label="固定资产净值" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="+formData.insureNum === 0"
              prop="insureData"
              ref="insureData"
              :label="
                `${['保险费率', '单位保险费', '保险费'][formData.insureType]}`
              "
            >
              <el-input
                placeholder="请输入"
                v-model="formData.insureData"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.insureNum === 1"
              v-model="formData.insureDataArr"
              prop="insureDataArr"
              ref="insureDataArr"
              :rules="rules.insureData"
              :label="
                `${['保险费率', '单位保险费', '保险费'][formData.insureType]}`
              "
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">材料费</el-divider>
            <el-form-item
              label="材料费数据单位"
              prop="materialType"
              ref="materialType"
            >
              <el-select
                placeholder="请选择材料费数据单位"
                :disabled="backend"
                v-model="formData.materialType"
              >
                <el-option label="%" :value="0"></el-option>
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="材料费计算方式"
              prop="materialNum"
              ref="materialNum"
            >
              <el-select
                placeholder="请选择材料费计算方式"
                :disabled="backend"
                v-model="formData.materialNum"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="+formData.materialNum === 0"
              prop="materialConsumption"
              ref="materialConsumption"
              :label="
                `${['材料费率', '单位材料费', '材料费'][formData.materialType]}`
              "
            >
              <el-input
                placeholder="请输入"
                v-model="formData.materialConsumption"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.materialNum === 1"
              v-model="formData.materialConsumptionArr"
              prop="materialConsumptionArr"
              ref="materialConsumptionArr"
              :rules="rules.materialConsumption"
              :label="
                `${['材料费率', '单位材料费', '材料费'][formData.materialType]}`
              "
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">摊销费</el-divider>
            <el-form-item
              label="无形资产摊销年限（年）"
              prop="immaterialAmortization"
              ref="immaterialAmortization"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.immaterialAmortization"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="其他资产摊销年限（年）"
              prop="otherAmortization"
              ref="otherAmortization"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.otherAmortization"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">其他费用</el-divider>
            <el-form-item
              label="其他费用计算方式"
              prop="otherFeeNum"
              ref="otherFeeNum"
            >
              <el-select :disabled="backend" v-model="formData.otherFeeNum">
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="其他费用1单位"
              prop="otherFeeType1"
              ref="otherFeeType1"
            >
              <el-select
                placeholder="请选择单位"
                :disabled="backend"
                v-model="formData.otherFeeType1"
              >
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="+formData.otherFeeNum === 0"
              label="其他费用1"
              prop="otherFee1"
              ref="otherFee1"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.otherFee1"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.otherFeeNum === 1"
              v-model="formData.otherFee1Arr"
              label="其他费用1"
              prop="otherFee1Arr"
              ref="otherFee1Arr"
              :rules="rules.otherFee1"
              :count="operatingPeriodCount + constructionPeriodCount"
            ></multi-input>
            <el-form-item
              label="其他费用2单位"
              prop="otherFeeType2"
              ref="otherFeeType2"
            >
              <el-select
                placeholder="请选择单位"
                :disabled="backend"
                v-model="formData.otherFeeType2"
              >
                <el-option label="元/kw" :value="1"></el-option>
                <el-option label="万元" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="+formData.otherFeeNum === 0"
              label="其他费用2"
              prop="otherFee2"
              ref="otherFee2"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.otherFee2"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.otherFeeNum === 1"
              v-model="formData.otherFee2Arr"
              label="其他费用2"
              prop="otherFee2Arr"
              ref="otherFee2Arr"
              :rules="rules.otherFee2"
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>
          </el-collapse-item>

          <el-collapse-item title="收入和税金" name="income">
            <el-divider content-position="left">产量</el-divider>
            <el-form-item
              label="等效利用小时数（h）"
              prop="equivalentHour"
              ref="equivalentHour"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.equivalentHour"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="上网电量计算方式"
              prop="energyType"
              ref="energyType"
            >
              <el-select
                placeholder="请选择上网电量计算方式"
                :disabled="backend"
                v-model="formData.energyType"
              >
                <el-option label="自动计算" :value="0"></el-option>
                <el-option label="手动输入" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <multi-input
              v-model="formData.energyData_Arr"
              prop="energyData_Arr"
              ref="energyData_Arr"
              :defaultValue="1"
              :rules="rules.energyData"
              :label="['发电量系数', '电量数据（kWH）'][formData.energyType]"
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-divider content-position="left">装机进度</el-divider>
            <cap-year-input
              v-model="formData.ongridCapacityArr"
              prop="ongridCapacityArr"
              ref="ongridCapacityArr"
              :rules="rules.ongridCapacity"
              label="各年新增装机情况（MW）"
              :cap="+formData.cap"
              :count="constructionPeriodCount"
            >
            </cap-year-input>

            <el-divider content-position="left">税率</el-divider>
            <el-form-item label="增值税率（%）" prop="vat" ref="vat">
              <el-input placeholder="请输入" v-model="formData.vat"></el-input>
            </el-form-item>
            <el-form-item
              label="所得税计算方式"
              prop="incomeTaxType"
              ref="incomeTaxType"
            >
              <el-select
                placeholder="请选择所得税计算方式"
                :disabled="backend"
                v-model="formData.incomeTaxType"
              >
                <el-option label="各年相同" :value="0"></el-option>
                <el-option label="各年不同" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="+formData.incomeTaxType === 0"
              label="企业所得税率（%）"
              prop="incomeTaxRate"
              ref="incomeTaxRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.incomeTaxRate"
              ></el-input>
            </el-form-item>
            <multi-input
              v-if="+formData.incomeTaxType === 1"
              v-model="formData.incomeTaxRateArr"
              label="企业所得税率（%）"
              prop="incomeTaxRateArr"
              ref="incomeTaxRateArr"
              :rules="rules.incomeTaxRate"
              :count="operatingPeriodCount + constructionPeriodCount"
            >
            </multi-input>

            <el-form-item
              label="城市维护建设费率（%）"
              prop="urbanConstructionTaxRate"
              ref="urbanConstructionTaxRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.urbanConstructionTaxRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="教育附加费（%）"
              prop="educationAddRate"
              ref="educationAddRate"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.educationAddRate"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="增值税即征即退"
              prop="vatPolicy"
              ref="vatPolicy"
            >
              <el-select placeholder="请选择" v-model="formData.vatPolicy">
                <el-option label="无" :value="0"></el-option>
                <el-option label="有" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="所得税N免（年）"
              prop="incomeTaxNexempt"
              ref="incomeTaxNexempt"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.incomeTaxNexempt"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="所得税N减半（年）"
              prop="incomeTaxNhalved"
              ref="incomeTaxNhalved"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.incomeTaxNhalved"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="法定盈余公积金比例（%）"
              prop="proportionSurplusReserve"
              ref="proportionSurplusReserve"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.proportionSurplusReserve"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="任意盈余公积金比例（%）"
              prop="proportionSurplusDiscretionary"
              ref="proportionSurplusDiscretionary"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.proportionSurplusDiscretionary"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="应付利润比例（%）"
              prop="profitPayableRatio"
              ref="profitPayableRatio"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.profitPayableRatio"
              ></el-input>
            </el-form-item>

            <el-divider content-position="left">电价</el-divider>
            <el-form-item label="税类型" prop="taxType" ref="taxType">
              <el-select placeholder="请选择" v-model="formData.taxType">
                <el-option label="所得税" :value="0"></el-option>
                <el-option label="调整所得税" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="含税电价（元/kwh）"
              prop="priceWith"
              ref="priceWith"
            >
              <e-price v-model="formData.priceWith"></e-price>
            </el-form-item>
            <el-form-item
              label="是否分两阶段电价"
              prop="priceType"
              ref="priceType"
            >
              <el-select placeholder="请选择" v-model="formData.priceType">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="第一阶段小时数（h）"
              v-if="+formData.priceType === 1"
              prop="hoursLimit"
              ref="hoursLimit"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.hoursLimit"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="+formData.priceType === 1"
              prop="priceWith2"
              ref="priceWith2"
              label="第二阶段含税电价（元/kwh）"
            >
              <el-input
                placeholder="请输入"
                v-model="formData.priceWith2"
              ></el-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="计算LCOE" name="lcoe">
            <el-form-item label="IRR类型" prop="irrType" ref="irrType">
              <el-select
                placeholder="请选择还款类型"
                v-model="formData.irrType"
              >
                <el-option label="项目投资税后收益率" :value="0"></el-option>
                <el-option label="资本金收益率" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="IRR大小" prop="irrData" ref="irrData">
              <el-input
                placeholder="请输入"
                v-model="formData.irrData"
              ></el-input>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="敏感性分析" name="sensitive">
            <el-form-item
              label="是否敏感性分析"
              prop="whetherSense"
              ref="whetherSense"
            >
              <el-select placeholder="请选择" v-model="formData.whetherSense">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <div v-if="+formData.whetherSense === 1">
              <el-form-item
                label="总投资浮动（%）"
                prop="totalInvestArr_Arr"
                ref="totalInvestArr_Arr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.totalInvestArr_Arr"
                >
                </inputs>
              </el-form-item>
              <el-form-item
                label="电量浮动（%）"
                prop="energyDataArr_Arr"
                ref="energyDataArr_Arr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.energyDataArr_Arr"
                ></inputs>
              </el-form-item>
              <el-form-item
                label="含税电价浮动（%）"
                prop="priceWithArr_Arr"
                ref="priceWithArr_Arr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.priceWithArr_Arr"
                ></inputs>
              </el-form-item>
              <el-form-item
                label="长期贷款利率浮动（%）"
                prop="loanInterestRateArr_Arr"
                ref="loanInterestRateArr_Arr"
              >
                <inputs
                  placeholder="请输入"
                  :count="5"
                  v-model="formData.loanInterestRateArr_Arr"
                ></inputs>
              </el-form-item>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div class="bottom-tool">
      <el-button type="text" @click="reset" v-if="canSave">重置</el-button>
      <el-button type="text" @click="save" v-if="canSave">{{
        backend ? '保存' : '保存并计算'
      }}</el-button>
    </div>
  </div>
  <div v-else>
    <div class="fin-form empty-form">暂无数据</div>
  </div>
</template>

<script>
import sum from 'lodash/sum';
import isEmpty from 'lodash/isEmpty';
// import isNil from 'lodash/isNil';

import { number, checkNumber, convertRule } from '@/utils/rules';
import TotalInvest from './total-invest';
import TotalInvestDialog from './total-invest-dialog';
import EPrice from './e-price';
import MultiInput from './multi-input';
import CapYearInput from './cap-year-input';
import Inputs from './inputs';

export default {
  components: {
    TotalInvest,
    TotalInvestDialog,
    EPrice,
    Inputs,
    MultiInput,
    CapYearInput
  },
  props: {
    formData: {
      type: Object,
      default: () => null
    },
    project: {
      type: Object,
      default: () => null
    },
    economic: {
      type: Object,
      default: () => null
    },
    backend: {
      type: Boolean,
      default: () => false
    },
    theme: {
      type: String,
      default: () => 'dark'
    },
    defaultData: {
      type: Object,
      defualt: () => null
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(2000, 0, 1).getTime();
        }
      },
      collapseModel: [
        'relate',
        'important',
        'basic',
        'cost',
        'income',
        'type',
        'lcoe',
        'sensitive'
      ],
      formArrKey: [
        'constructionInvest',
        'otherAssets',
        'immaterialAssets',
        'incomeTaxRate',
        'maintainData',
        'insureData',
        'materialConsumption',
        'otherFee1',
        'otherFee2',
        'ongridCapacity',
        'staffCapacity',
        'staffSalary',
        'welfareRate',
        'depreciableData',
        'energyData'
      ],
      rules: {
        name: [
          {
            required: true,
            pattern: /^.{1,30}$/,
            message: '名称长度为1到30个字符',
            trigger: 'change'
          }
        ],
        operatingPeriod: [
          number({
            min: 10,
            max: 30,
            equal: { min: true, max: true },
            precision: 0
          })
        ],
        constructionPeriod: [
          number({
            min: 1,
            max: 5,
            equal: { min: true, max: true },
            precision: 0
          })
        ],
        constructionStarttime: [
          { required: true, message: '请输入开工年份', trigger: 'change' }
        ],
        constructionInvest: [
          number({ min: 50, max: 20000000, equal: { min: true, max: true } })
        ],
        cap: [
          number({ min: 0.1, max: 10000, equal: { min: true, max: true } })
        ],
        staticTotalInvestment: [
          number({ min: 20, max: 20000000, equal: { min: true, max: true } })
        ],
        vatRate: [number({ min: 0, max: 30, equal: { min: true, max: true } })],
        immaterialAssets: [
          number({ min: 0, equal: { min: true } }),
          convertRule({
            message: '必须小于分年度投资总和',
            validator: value =>
              value < sum(this.formData.constructionInvestArr.map(val => +val))
          })
        ],
        otherAssets: [
          number({ min: 0, equal: { min: true } }),
          convertRule({
            message: '必须小于分年度投资总和',
            validator: value =>
              value < sum(this.formData.constructionInvestArr.map(val => +val))
          })
        ],
        capitalRate: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        marr: [number({ min: 0, max: 20, equal: { min: true, max: true } })],
        marrBeforeTax: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        marrAfterTax: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        fluidUnit: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        fluidLoanRatio: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        fluidLoanRate: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        shortLoanRate: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        repayType: [{ required: true, trigger: 'change' }],
        repaymentPeriod: [
          convertRule({
            required: true,
            message: () => {
              return '请输入1~风场运营期之间的数字';
            },
            validator: value => {
              return checkNumber(value, {
                min: 1,
                max: this.formData.operatingPeriod,
                equal: { min: true, max: true }
              });
            }
          })
        ],
        loanInterestRate: [
          number({ min: 0, max: 20, equal: { min: true, max: true } })
        ],
        salvage: [number({ min: 0, max: 10, equal: { min: true, max: true } })],
        depreciableType: [{ required: true, trigger: 'change' }],
        depreciableData: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.depreciableType;
              if (type === 0) {
                return '请输入5-30之间的数字';
              }
              if (type === 1) {
                return '请输入4-20之间的数字';
              }
              return '请输入0-分年投资总和的数字';
            },
            validator: value => {
              const type = +this.formData.depreciableType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 5,
                  max: 30,
                  equal: { min: true, max: true }
                });
              }
              if (type === 1) {
                return checkNumber(value, {
                  min: 4,
                  max: 20,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                max: sum(this.formData.constructionInvestArr.map(val => +val)),
                equal: { min: true, max: true }
              });
            }
          })
        ],
        maintainType: [{ required: true, trigger: 'change' }],
        maintainNum: [{ required: true, trigger: 'change' }],
        maintainData: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.maintainType;
              if (type === 0) {
                return '请输入0-20之间的数字';
              }
              if (type === 1) {
                return '请输入0-1000之间的数字';
              }
              return '请输入大于等于0的数字';
            },
            validator: value => {
              const type = +this.formData.maintainType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 20,
                  equal: { min: true, max: true }
                });
              }
              if (type === 1) {
                return checkNumber(value, {
                  min: 0,
                  max: 1000,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                equal: { min: true }
              });
            }
          })
        ],
        staffTypeNum: [
          number({ min: 0, max: 5, equal: { min: true, max: true } })
        ],
        staffCapacity: [
          number({ min: 0, max: 1000, equal: { min: true, max: true } })
        ],
        staffSalary: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        welfareRate: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        insureType: [{ required: true, trigger: 'change' }],
        insureNum: [{ required: true, trigger: 'change' }],
        insureRaw: [{ required: true, trigger: 'change' }],
        insureData: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.insureType;
              if (type === 0) {
                return '请输入0-1之间的小数';
              }
              if (type === 1) {
                return '请输入0-100之间的数字';
              }
              return '请输入大于等于0的数字';
            },
            validator: value => {
              const type = +this.formData.insureType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 1,
                  equal: { min: true, max: true }
                });
              }
              if (type === 1) {
                return checkNumber(value, {
                  min: 0,
                  max: 100,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                equal: { min: true }
              });
            }
          })
        ],
        materialType: [{ required: true, trigger: 'change' }],
        materialNum: [{ required: true, trigger: 'change' }],
        materialConsumption: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.materialType;
              if (type === 0) {
                return '请输入0-30之间的数字';
              }
              if (type === 1) {
                return '请输入0-100之间的数字';
              }
              return '请输入大于0的数字';
            },
            validator: value => {
              const type = +this.formData.materialType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 30,
                  equal: { min: true, max: true }
                });
              }
              if (type === 1) {
                return checkNumber(value, {
                  min: 0,
                  max: 100,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0
              });
            }
          })
        ],
        immaterialAmortization: [
          convertRule({
            required: true,
            message: '请输入0-运行期之间的数字',
            validator: value =>
              checkNumber(value, {
                min: 0,
                max: this.formData.operatingPeriod,
                equal: { min: true, max: true }
              })
          })
        ],
        otherAmortization: [
          convertRule({
            required: true,
            message: '请输入0-运行期之间的数字',
            validator: value =>
              checkNumber(value, {
                min: 0,
                max: this.formData.operatingPeriod,
                equal: { min: true, max: true }
              })
          })
        ],
        otherFeeNum: [{ required: true, trigger: 'change' }],
        otherFeeType1: [{ required: true, trigger: 'change' }],
        otherFee1: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.otherFeeNum;
              if (type === 0) {
                return '请输入0-100之间的数字';
              }
              return '请输入大于等于0的数字';
            },
            validator: value => {
              const type = +this.formData.otherFeeNum;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 100,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                equal: { min: true }
              });
            }
          })
        ],
        otherFeeType2: [{ required: true, trigger: 'change' }],
        otherFee2: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.otherFeeNum;
              if (type === 0) {
                return '请输入0-100之间的数字';
              }
              return '请输入大于等于0的数字';
            },
            validator: value => {
              const type = +this.formData.otherFeeNum;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 100,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                equal: { min: true }
              });
            }
          })
        ],
        energyType: [{ required: true, trigger: 'change' }],
        equivalentHour: [
          number({ min: 0, max: 8760, equal: { min: true, max: true } })
        ],
        energyData: [
          convertRule({
            required: true,
            message: () => {
              const type = +this.formData.energyType;
              if (type === 0) {
                return '请输入大于等于0小于等于2的数字';
              }
              return '请输入大于等于0的数字';
            },
            validator: value => {
              const type = +this.formData.energyType;
              if (type === 0) {
                return checkNumber(value, {
                  min: 0,
                  max: 2,
                  equal: { min: true, max: true }
                });
              }
              return checkNumber(value, {
                min: 0,
                equal: { min: true }
              });
            }
          })
        ],
        ongridCapacity: [
          convertRule({
            required: true,
            message: '请输入0-装机容量之间的数字',
            validator: value =>
              checkNumber(value, {
                min: 0,
                max: this.formData.cap,
                equal: { min: true, max: true }
              })
          })
        ],
        incomeTaxType: [{ required: true, trigger: 'change' }],
        vat: [number({ min: 0, max: 20, equal: { min: true, max: true } })],
        incomeTaxRate: [
          number({ min: 0, max: 50, equal: { min: true, max: true } })
        ],
        urbanConstructionTaxRate: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        vatPolicy: [{ required: true, trigger: 'change' }],
        educationAddRate: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        incomeTaxNexempt: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        incomeTaxNhalved: [
          number({ min: 0, max: 10, equal: { min: true, max: true } })
        ],
        proportionSurplusReserve: [
          number({ min: 0, max: 20, equal: { max: true } })
        ],
        proportionSurplusDiscretionary: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        profitPayableRatio: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        taxType: [{ required: true, trigger: 'change' }],
        priceType: [{ required: true, trigger: 'change' }],
        priceWith: [number({ min: 0, max: 10 })],
        priceWith2: [number({ min: 0, max: 10 })],
        hoursLimit: [
          number({ min: 0, max: 8760, equal: { min: true, max: true } })
        ],
        irrType: [{ required: true, trigger: 'change' }],
        irrData: [
          number({ min: 0, max: 100, equal: { min: true, max: true } })
        ],
        whetherSense: [{ required: true, trigger: 'change' }],
        totalInvestArr_Arr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ],
        energyDataArr_Arr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ],
        priceWithArr_Arr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ],
        loanInterestRateArr_Arr: [
          convertRule({
            required: false,
            message: '请输入整数'
            // validator: value => {
            //   if (isEmpty(value)) return true;
            //   return isNil(
            //     value.find(
            //       item =>
            //         !checkNumber(item, {
            //           precision: 0
            //         })
            //     )
            //   );
            // }
          })
        ]
      },
      investDetail: [],
      totalInvestVisible: false
    };
  },
  computed: {
    nameLabel() {
      if (!this.economic) {
        return this.project?.label;
      }
      return this.economic.labelPath;
    },
    baseValue() {
      return +this.formData?.landOrSea === 1 ? 700 : 1500;
    },
    canSave() {
      return this.backend || this.economic?.isOwnerFlag !== 0;
    },
    constructionPeriodCount() {
      const count = +this.formData.constructionPeriod;
      if (window.isNaN(count)) return 1;
      if (count > 5) {
        return 5;
      }
      if (count < 1) {
        return 1;
      }
      return count;
    },
    operatingPeriodCount() {
      const count = +this.formData.operatingPeriod;
      if (window.isNaN(count)) return 1;
      if (count > 30) {
        return 30;
      }
      if (count < 10) {
        return 10;
      }
      return count;
    },
    staffTypeNumCount() {
      const count = +this.formData.staffTypeNum;
      if (window.isNaN(count)) return 1;
      if (count > 5) {
        return 5;
      }
      if (count < 0) {
        return 0;
      }
      return count;
    }
  },
  watch: {
    'formData.depreciableType': function(val) {
      if (!this.defaultData) return;
      if (val !== this.defaultData.depreciableType) {
        this.formData.depreciableData = '';
        this.formData.depreciableDataArr = [];
      } else {
        this.formData.depreciableData = this.defaultData.depreciableData;
        this.formData.depreciableDataArr = this.defaultData.depreciableDataArr;
      }
    },
    'formData.maintainType': function(val) {
      if (!this.defaultData) return;
      if (
        val !== this.defaultData.maintainType ||
        this.formData.maintainNum !== this.defaultData.maintainNum
      ) {
        this.formData.maintainData = '';
        this.formData.maintainDataArr = [];
      } else {
        this.formData.maintainData = this.defaultData.maintainData;
        this.formData.maintainDataArr = this.defaultData.maintainDataArr;
      }
    },
    'formData.maintainNum': function(val) {
      if (!this.defaultData) return;
      if (
        this.formData.maintainType !== this.defaultData.maintainType ||
        val !== this.defaultData.maintainNum
      ) {
        this.formData.maintainData = '';
        this.formData.maintainDataArr = [];
      } else {
        this.formData.maintainData = this.defaultData.maintainData;
        this.formData.maintainDataArr = this.defaultData.maintainDataArr;
      }
    },
    'formData.insureNum': function(val) {
      if (!this.defaultData) return;
      if (
        val !== this.defaultData.insureNum ||
        this.formData.insureType !== this.defaultData.insureType
      ) {
        this.formData.insureData = '';
        this.formData.insureDataArr = [];
      } else {
        this.formData.insureData = this.defaultData.insureData;
        this.formData.insureDataArr = this.defaultData.insureDataArr;
      }
    },
    'formData.insureType': function(val) {
      if (!this.defaultData) return;
      if (
        this.formData.insureNum !== this.defaultData.insureNum ||
        val !== this.defaultData.insureType
      ) {
        this.formData.insureData = '';
        this.formData.insureDataArr = [];
      } else {
        this.formData.insureData = this.defaultData.insureData;
        this.formData.insureDataArr = this.defaultData.insureDataArr;
      }
    },
    'formData.cap': function(val) {
      if (!this.defaultData) return;
      if (isEmpty(this.formData.staffCapacityArr)) return;
      const num = Math.floor(10 * Math.pow(val / 50, 0.7));
      this.formData.staffCapacityArr = this.formData.staffCapacityArr.map(
        () => num
      );
      // },
      // 'formData.staticTotalInvestment': function() {
      //   const { constructionPeriodCount } = this.formData;
      //   if (!constructionPeriodCount) return;
    }
  },
  methods: {
    changeLandOrSea(val) {
      this.formData.landOrSea = val;
      this.$emit('landChange', val);
    },
    changeInvestDetail(list) {
      this.formData.totaInvestDetailList = list;
    },
    changeStaticTotalInvestment(value) {
      this.formData.staticTotalInvestment = value;
    },
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$emit('save');
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            if (i.indexOf('.') !== -1) {
              dom = this.$refs[i.split('.')[0]];
            }
            if (
              Object.prototype.toString.call(dom) !== '[object Object]' &&
              dom
            ) {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            } //第一种方法（包含动画效果）
            if (!dom) continue;
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
            break; //因为我们只需要检测一项,所以就可以跳出循环了
          }
          console.error(object);
        }
      });
    },
    reset() {
      this.$emit('reset');
    }
  }
};
</script>
<style lang="less" scoped>
.fin-form {
  height: 100%;
  position: relative;

  .fin-form-header {
    padding: 1px 16px;
    display: flex;
    font-size: 16px;
    line-height: 30px;
    height: 30px;
  }

  .fin-form-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 28px;
    overflow: auto;
  }

  .bottom-tool {
    font-size: 4px;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: right;
    padding-right: 20px;
    height: 28px;
    background-color: @bgColor;

    .el-button--text {
      color: #fff;
    }
  }

  &.empty-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(50%);
    font-size: 14px;
    color: #8f9197;
    height: auto;
  }

  &.dark {
    .fin-form-header {
      background: @brandColor;
    }

    .fin-form-content {
      top: 30px;
      bottom: 30px;
    }

    .bottom-tool {
      background-color: @brandColor;
    }

    /deep/.el-form-item {
      .el-form-item__label {
        color: #fff;
      }

      .el-form-item__content {
        color: #fff;
      }
    }

    /deep/.el-collapse {
      background: @bgColor;
      color: #fff;
      border-top: none;
      border-bottom: none;

      .el-input-group__append {
        background-color: transparent;
        padding: 0 5px;
      }
      .el-collapse-item__header,
      .el-collapse-item__wrap {
        background: @bgColor;
        color: #fff;
        border-bottom: 1px solid @bgColor;
      }

      .el-collapse-item__header {
        background: #3271a1;
      }

      .el-form-item__label {
        color: #fff;
      }
    }

    /deep/.el-divider {
      .el-divider__text {
        background: @bgColor;
        color: #fff;
      }
    }

    /deep/.el-radio {
      color: #fff;
      .el-radio__label {
        color: #fff;
      }
    }
  }

  /deep/.el-form-item {
    .el-form-item__label {
      text-align: right;
      width: 230px;
    }

    .el-form-item__content {
      min-width: 200px;
    }
  }

  /deep/.el-collapse {
    .el-input-group__append {
      border: none;
      border-bottom: 1px solid #fff;
    }

    .el-collapse-item__header,
    .el-collapse-item__wrap {
      padding-left: 16px;
    }

    .el-collapse-item__header {
      height: 30px;
    }

    .el-collapse-item__content {
      .el-form-item {
        width: 48%;
      }
    }
  }

  /deep/.data-select {
    .el-select {
      width: auto;
    }
  }

  /deep/.el-select {
    .el-input {
      .el-input__inner:read-only {
        border-bottom: 1px solid #fff;
      }

      &.is-disabled {
        .el-input__inner {
          background-color: #fff;
          border-color: #fff;
          color: #000;
          cursor: default;
        }

        .el-input__icon {
          cursor: default;
        }
      }
    }
  }

  /deep/.el-input {
    .el-input__inner:read-only {
      border: 0;
    }
  }
}
</style>
